// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "高等数学（一）",
      "tec": "马婷婷",
      "week": "6-17周",
      "add": "教学楼D座418教务处"
    },
    [
      {
        "sub": "工程计算系统",
        "tec": "赵越",
        "week": "6-9,17周",
        "add": "实训楼C座303"
      },
      {
        "sub": "工程计算系统",
        "tec": "赵越",
        "week": "10-16周",
        "add": "教学楼C座214教务"
      }
    ],
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[05-06节]）"
    },
    {
      "sub": "英语听说（一）",
      "tec": "外聘3",
      "week": "6-10周",
      "add": "204国教"
    },
    0
  ],
  "2": [
    {
      "sub": "高等数学（一）",
      "tec": "马婷婷",
      "week": "6-17周",
      "add": "教学楼D座418教务处"
    },
    {
      "sub": "大学英语（一）",
      "tec": "曹悦",
      "week": "6-17周",
      "add": "204国教"
    },
    [
      {
        "sub": "工程基础",
        "tec": "潘萍萍",
        "week": "6-8周",
        "add": "教学楼A座215机房"
      },
      {
        "sub": "工程基础",
        "tec": "潘萍萍",
        "week": "9-16周",
        "add": "教学楼C座214教务"
      }
    ],
    {
      "sub": "大学物理",
      "tec": "赵明明",
      "week": "10-17周",
      "add": "教学楼C座309教务"
    },
    {
      "sub": "军事理论",
      "tec": "于瑶",
      "week": "6-13,15周",
      "add": "教学楼C座214教务"
    }
  ],
  "3": [
    {
      "sub": "大学物理",
      "tec": "赵明明",
      "week": "6-17周",
      "add": "教学楼C座309教务"
    },
    [
      {
        "sub": "工程计算系统",
        "tec": "赵越",
        "week": "6-9,17周",
        "add": "实训楼C座303"
      },
      {
        "sub": "工程计算系统",
        "tec": "赵越",
        "week": "10-16周",
        "add": "实训楼C座303"
      }
    ],
    0,
    [
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "6-11周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "12周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "12周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "13周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "13周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "14周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "14周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "15周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "15周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "16周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "16周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "17周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "17周",
        "add": "教学楼C座210教务"
      }
    ],
    {
      "sub": "形势与政策",
      "tec": "祝嘉悦",
      "week": "6-9周",
      "add": "教学楼C座215教务"
    }
  ],
  "4": [
    [
      {
        "sub": "工程计算系统",
        "tec": "赵越",
        "week": "6-9,17周",
        "add": "实训楼C座303"
      },
      {
        "sub": "工程计算系统",
        "tec": "赵越",
        "week": "10-16周",
        "add": "实训楼C座303"
      }
    ],
    {
      "sub": "大学英语（一）",
      "tec": "曹悦",
      "week": "6-17周",
      "add": "实训楼E座406语音室"
    },
    {
      "sub": "心理健康与调适",
      "tec": "王艳峰",
      "week": "6-15周",
      "add": "教学楼C座212教务"
    },
    [
      {
        "sub": "工程基础",
        "tec": "潘萍萍",
        "week": "6-8周",
        "add": "教学楼A座215机房"
      },
      {
        "sub": "工程基础",
        "tec": "潘萍萍",
        "week": "9-16周",
        "add": "教学楼A座215机房"
      }
    ],
    [
      {
        "sub": "工程基础",
        "tec": "潘萍萍",
        "week": "6-8周",
        "add": "教学楼A座215机房"
      },
      {
        "sub": "工程基础",
        "tec": "潘萍萍",
        "week": "9-16周",
        "add": "教学楼A座215机房"
      }
    ]
  ],
  "5": [
    {
      "sub": "工程基础",
      "tec": "潘萍萍",
      "week": "6-8周",
      "add": "教学楼A座215机房"
    },
    {
      "sub": "大学物理",
      "tec": "赵明明",
      "week": "6-17周",
      "add": "教学楼C座309教务"
    },
    {
      "sub": "高等数学（一）",
      "tec": "马婷婷",
      "week": "6-17周",
      "add": "教学楼D座418教务处"
    },
    [
      {
        "sub": "就业创业指导",
        "tec": "赵传钰",
        "week": "6-10周",
        "add": "教学楼C座214教务"
      },
      {
        "sub": "英语听说（一）",
        "tec": "外聘3",
        "week": "11-17周",
        "add": "204国教"
      }
    ],
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
